import { render, staticRenderFns } from "./DashboardManager.vue?vue&type=template&id=70dfc7b5&scoped=true"
import script from "./DashboardManager.vue?vue&type=script&lang=js"
export * from "./DashboardManager.vue?vue&type=script&lang=js"
import style0 from "./DashboardManager.vue?vue&type=style&index=0&id=70dfc7b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dfc7b5",
  null
  
)

export default component.exports